import axiosInstance from "../../../shared/api/axiosInstance.js";
import { baseUrl, GET_CATEGORY, CREATE_CATEGORY, EDIT_CATEGORY, DELETE_CATEGORY } from "../../../shared/api/endpoints.js";
import { configReq } from "../../../shared/lib/functions.js";

/** Loads the selected parent using the unchanged admin API contract. */
export function getCategory(id, token) {
  return axiosInstance(`${baseUrl}/${GET_CATEGORY}?id=${id}`, configReq(token));
}

/** Preserves multipart create/update payloads and response envelopes. */
export function saveCategory(formData, token, forEdit) {
  return forEdit ? axiosInstance.put(`${baseUrl}/${EDIT_CATEGORY}`, formData, configReq(token, true)) : axiosInstance.post(`${baseUrl}/${CREATE_CATEGORY}`, formData, configReq(token));
}

/** Deletes only the category explicitly selected in the existing confirmation dialog. */
export function deleteCategory(id, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_CATEGORY}?id=${id}`, configReq(token));
}
